// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__NzGeQ","tooltip":"Tooltip_tooltip__LJE_u","title":"Tooltip_title__STQqE","content":"Tooltip_content__VXdki"};